<section class="syncing">
  <div *ngIf="syncingState !== SyncingState.TimedOut" class="syncing__dots" aria-label="Processing results">
    <span class="syncing__dot"></span>
    <span class="syncing__dot syncing__dot--delayed"></span>
    <span class="syncing__dot syncing__dot--late"></span>
  </div>

  <img
    *ngIf="syncingState === SyncingState.TimedOut"
    class="syncing__warning"
    src="assets/errors/warning-sign.png"
    alt="Warning sign"
  />

  <h2 *ngIf="syncingState === SyncingState.Initial" class="syncing__title">
    Processing results
  </h2>

  <h2 *ngIf="syncingState === SyncingState.TimedOut" class="syncing__title">
    Something went wrong
  </h2>

  <p *ngIf="syncingState === SyncingState.Initial" class="syncing__body">
    Hold tight while we finish processing your results, this may take a moment.
  </p>

  <p *ngIf="syncingState === SyncingState.Delayed" class="syncing__body">
    This is taking longer than expected. We apologize for the inconvenience. Reach out to your Business Advisor in case you have any questions.
  </p>

  <p *ngIf="syncingState === SyncingState.TimedOut" class="syncing__body">
    We were unable to finish processing your results. Contact your business advisor for assistance.
  </p>
</section>